import React, { type ChangeEventHandler, type FocusEventHandler, type ForwardedRef, type KeyboardEventHandler } from 'react';
import Styles from './FilledInput.module.scss';

export interface FilledInputProps {
    value: string;
    placeholder?: string;
    onChange?: ChangeEventHandler<HTMLInputElement>;
    onFocus?: FocusEventHandler<HTMLInputElement>;
    autoFocus?: boolean;
    border?: boolean;
    small?: boolean;
    dark?: boolean;
    noMargin?: boolean;
    onBlur?: FocusEventHandler<HTMLInputElement>;
    onKeyUp?: KeyboardEventHandler<HTMLInputElement>;
    disabled?: boolean;
    hasValidationError?: boolean;
    className?: string;
}

// eslint-disable-next-line react/display-name
const FilledInput = React.forwardRef((props: Readonly<FilledInputProps>, ref: ForwardedRef<HTMLInputElement>): React.ReactElement => {
    const { value, placeholder, onChange, onFocus, autoFocus, border, small, dark, noMargin, onBlur, onKeyUp, disabled, hasValidationError, className } = props;

    const classNames = [
        Styles.input,
        border ? Styles.border : undefined,
        small ? Styles.small : undefined,
        dark ? Styles.dark : undefined,
        hasValidationError ? Styles.hasValidationError : undefined,
        className ?? undefined,
        noMargin ? Styles.noMargin : undefined,
    ].join(' ');

    return (
        <input
            className={classNames}
            placeholder={placeholder ?? ''}
            value={value}
            onChange={onChange}
            ref={ref}
            autoFocus={autoFocus}
            onFocus={(e) => onFocus?.(e)}
            onBlur={(e) => onBlur?.(e)}
            onKeyUp={(e) => onKeyUp?.(e)}
            disabled={disabled ?? false}
        />
    );
});

export {
    FilledInput,
};
